export interface Locale {
    locale: string,
    code: string,
    text: string,
    flag: string
}

export const locales: Locale[] = [{
    locale: 'de',
    code: 'toolbar.locale.germanCode',
    text: 'toolbar.locale.germanText',
    flag: require('@/assets/flags/de.png')
}, {
    locale: 'en',
    code: 'toolbar.locale.englishCode',
    text: 'toolbar.locale.englishText',
    flag: require('@/assets/flags/en.png')
}, {
    locale: 'es',
    code: 'toolbar.locale.spanishCode',
    text: 'toolbar.locale.spanishText',
    flag: require('@/assets/flags/es.png')
}, {
    locale: 'fr',
    code: 'toolbar.locale.frenchCode',
    text: 'toolbar.locale.frenchText',
    flag: require('@/assets/flags/fr.png')
}, {
    locale: 'it',
    code: 'toolbar.locale.italianCode',
    text: 'toolbar.locale.italianText',
    flag: require('@/assets/flags/it.png')
}];

export function findLocale(code: string | null | undefined): Locale | undefined {
    if(!code) return undefined;
    
    const locale = parseLocaleCode(code);
    if(!locale) return undefined;

    return locales.find(i => i.locale === locale.language);
}

export function getLocalesString(separator?: string) {
    return locales.map(i => i.locale).join(separator);
}

export function getNeutralLanguage(code?: string): string | undefined {
    if(!code) return undefined;
    
    const locale = parseLocaleCode(code);
    if(!locale) return undefined;

    return locale.language;
}

export function normalizeLocaleName(code?: string): string | undefined {
    if(!code) return undefined;
    
    const locale = parseLocaleCode(code);
    if(!locale) return undefined;

    return locale.baseName;
}

export function isLocaleCodeValid(code?: string): boolean {
    if(!code) return false;
    return parseLocaleCode(code) !== undefined;
}

export function parseLocaleCode(code: string): Intl.Locale | undefined {
    try {
        return new Intl.Locale(code);
    } catch (e) {
        return undefined;
    }
}